<template>
  <div class="w-full h-full min-h-screen text-6xl bg-gray-200 p-8 text-center text-red-600">
    <i class="fas fa-circle-notch rotating"></i>
  </div>
</template>

<script>
export default {
  name: 'PleaceLoading'
}
</script>

<style scoped lang="scss">

</style>
